import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ConversionBonusState, ConversionBonusStatistics } from './ConversionBonus.types';

const initialState: ConversionBonusState = {
    data: {
        totalEarnings: 0,
        startDate: '',
        endDate: '',
        // End earnings date can be after the end of the contest depending on created referral count
        endEarningsDate: '',
    },
    requestStatus: 'initial',
    error: undefined,
};

const conversionBonusSlice = createSlice({
    name: 'conversionBonus',
    initialState,
    reducers: {
        fetchConversionBonusStarted: (state) => {
            state.requestStatus = 'pending';
            state.error = undefined;
        },
        fetchConversionBonusSucceeded: (state, action: PayloadAction<ConversionBonusStatistics>) => {
            state.data = action.payload;
            state.requestStatus = 'resolved';
        },
        fetchConversionBonusFailed: (state, action: PayloadAction<string>) => {
            state.error = action.payload;
            state.requestStatus = 'rejected';
        },
        resetConversionBonus: (state) => {
            state.data = {
                totalEarnings: 0,
                startDate: '',
                endDate: '',
                endEarningsDate: '',
            };
            state.requestStatus = 'initial';
            state.error = undefined;
        },
    },
});

export const {
    fetchConversionBonusStarted,
    fetchConversionBonusSucceeded,
    fetchConversionBonusFailed,
    resetConversionBonus,
} = conversionBonusSlice.actions;

export default conversionBonusSlice.reducer;
